import { Product } from "../../types/types";
import { ensureIsActive } from "@/utils/product/ensureIsActive.ts";

export function isMultiVariants(product: Product): boolean {
  const activeProduct = ensureIsActive(product);
  if (!activeProduct) return false;
  return Boolean(product.variants?.length > 1);
}
